import { storeActions } from "@/constants/store-actions";
import { debugLog } from "@/helpers/debug-log-helper";
import {
    isClaimAndCoverageExperimentActive,
    isNonClaimAndCoverageFlowEnabled,
    isNonClaimAndCoverageTestParentAccount,
} from "@/helpers/experiment-helper";
import { navigationScenarios } from "@/router/constants/navigation-scenarios";
import { routeData } from "@/router/constants/routes";
import { isVerifiedInsurance } from "@/router/methods/helpers/requires-verified-redirect";
import store from "@/store";

export async function insuranceCompanyBeforeEnter(to, from) {
    if (isVerifiedInsurance()) {
        const isNewInsuranceFlow = store.getters.order?.isNewInsuranceFlow;
        if (isNewInsuranceFlow) {
            return {
                name: routeData.POLICY_INFO.name,
                replace: true,
            };
        }
        return {
            name: routeData.HERITAGE.name,
            replace: true,
        };
    }
}

/**
 * Decides where insurance-company Continue should go.
 * Returns a navigation scenario for Vue routes, or null to send the user to Heritage.
 */
export async function getForwardNavigationScenario(selectedAccount) {
    const parentAccountNumber = selectedAccount?.parentAccountNumber;
    const experimentList = store.getters.applicationUser.experiments;

    // TODO: Where to send if can schedule online is false?
    if (!selectedAccount?.canScheduleOnline) {
        debugLog(
            `--- ${parentAccountNumber} Can schedule online is false, sending to vue app Insurance Details page ---`
        );
    }

    // C&C experiment active for this parent account number, send to vue app Policy Info page
    if (isClaimAndCoverageExperimentActive(parentAccountNumber, experimentList)) {
        debugLog(
            `--- ${parentAccountNumber} C&C experiment active for this parent account number, sending to vue app Policy Info page ---`
        );
        await store.dispatch(storeActions.SAVE_IS_NEW_INSURANCE_FLOW, true);
        return navigationScenarios.CLICKED_FORWARD_POLICY_INFO;
    }

    // C&C experiment setting is false, but is a C&C client, send to heritage
    if (selectedAccount?.isClaimAndCoverage) {
        debugLog(
            `--- ${parentAccountNumber} C&C experiment setting is false, but is a C&C client, sending to heritage ---`
        );
        await store.dispatch(storeActions.SAVE_IS_NEW_INSURANCE_FLOW, false);
        return null;
    }

    // Non integrated experiment setting is true, send to new insurance details page
    if (isNonClaimAndCoverageFlowEnabled(experimentList)) {
        debugLog(
            `--- ${parentAccountNumber} Non integrated experiment setting is true, sending to vue app Insurance Details page ---`
        );
        await store.dispatch(storeActions.SAVE_IS_NEW_INSURANCE_FLOW, true);
        return navigationScenarios.CLICKED_FORWARD_NON_CLAIM_AND_COVERAGE;
    }

    // Non integrated experiment setting is false, but a parent account is NON_CLAIM_AND_COVERAGE_TEST_PARENT_ACCOUNT experiment
    // contains a specific parent account number you wish to send to the vue app insurance details page
    if (isNonClaimAndCoverageTestParentAccount(parentAccountNumber, experimentList)) {
        debugLog(
            `--- ${parentAccountNumber} Non integrated experiment setting is false, but a parent account is NON_CLAIM_AND_COVERAGE_TEST_PARENT_ACCOUNT experiment contains a specific parent account number, sending to vue app Insurance Details page ---`
        );
        await store.dispatch(storeActions.SAVE_IS_NEW_INSURANCE_FLOW, true);
        return navigationScenarios.CLICKED_FORWARD_NON_CLAIM_AND_COVERAGE;
    }

    await store.dispatch(storeActions.SAVE_IS_NEW_INSURANCE_FLOW, false);
    return null;
}
